import React from 'react'
import { Link } from 'react-router-dom';

function About() {
  return (
    <section className="bg-color-dark">
      <div className="bg-color-dark mx-img-section">
          <img
              src="assets/images/Teman Suit Standing.png"
              alt="Teman Beck in Gray Suit"
              className="absolute mx-img-section bg-color-dark py-12 pl-16 sm:flex opacity-light sm:opacity-full"
              
              
          />
      </div>
      <div className='relative text-white sm:pl-50per px-24 py-12 mt-24'>
        <div>            
          <h2 className='px-18 py-12 text-center mt-42 text-42px'>
            The Architect Behind
            <span className='text-accent-dark'> the Products</span>
          </h2> 
            <hr className='mt-16 text-secondary-dark' style={{ maxWidth: 540 }}/>              
            <p className='px-18 py-12 mt-16 mx-auto letter-spacing-13' style={{ maxWidth: 540 }}>
              Hello, I'm <span className='text-accent-dark'>Teman Beck</span>, the founder and architect of Beck Develops.
            </p>
            <p className='px-18 py-12 mx-auto letter-spacing-13' style={{ maxWidth: 540 }}>
              My journey into engineering wasn't traditional. It started with managing the electrical integrity of a $10 billion amphibious assault ship in the U.S. Navy.
            </p>
            <p className='px-18 py-12 mx-auto letter-spacing-13' style={{ maxWidth: 540 }}>
              For eight years, I was an Electrician's Mate, responsible for 440v powerplants and, most critically, ship-wide fire prevention systems. In that environment, failure isn't an option, and reliability is the only metric that matters. That experience forged a deep-seated discipline in high-reliability systems, meticulous planning, and safety-critical execution.
            </p>
        </div>
        <hr className='mt-16 mx-auto text-secondary-dark' style={{ maxWidth: 80 }}/> 
        <div>
          <p className='px-18 py-12 mt-16 mx-auto letter-spacing-13' style={{ maxWidth: 540 }}>
            When I transitioned to software engineering, I brought that same discipline with me. I saw that the web was no longer just about pages; it was about building complex, distributed systems that people rely on. My post-naval career led me to tackle complex technical challenges, from modernizing core systems by refactoring monolithic SOAP APIs into scalable RESTful microservices, to consolidating disparate email services using Kafka and GCP.
          </p>  
        </div>
        <hr className='mt-16 mx-auto text-secondary-dark' style={{ maxWidth: 80 }}/> 
        
      </div>
      <div className='px-48'>
        <div className='text-white'>
          <p className='py-12 mt-16 mx-auto letter-spacing-13' style={{ maxWidth: 840 }}>
            At Beck Develops, I leverage this diverse background to build products that solve real-world problems. My mission is to architect innovative, secure, and reliable software and hardware solutions—transforming ambitious visions into tangible, market-ready products.
          </p>   
        </div>
        <hr className='mt-16 mx-auto text-secondary-dark' style={{ maxWidth: 80 }}/>
      </div>
      <div className='relative text-white'>
        <div className='px-48'>
          <h3 className='text-accent-dark text-28px text-center py-12 mt-16'>Featured Skills</h3>
          <div className='grid grid-cols-2 md:grid-cols-3 gap-16 mx-auto mt-24' style={{ maxWidth: 840 }}>
            <div className='text-center p-12'>Full-Stack Architecture</div>
            <div className='text-center p-12'>IoT & Embedded Systems</div>
            <div className='text-center p-12'>SaaS & Multi-Tenancy</div>
            <div className='text-center p-12'>Secure Backends</div>
            <div className='text-center p-12'>Modern Web (Next.js, React)</div>
            <div className='text-center p-12'>Cloud Infrastructure</div>
            <div className='text-center p-12'>Monetization & Subscriptions</div>
            <div className='text-center p-12'>Microservices Architecture</div>
          </div>
        </div>
        <hr className='mt-16 mx-auto text-secondary-dark' style={{ maxWidth: 80 }}/>
        <div className='px-48'> 
          <p className='py-12 mt-16 mx-auto letter-spacing-13 text-center' style={{ maxWidth: 840 }}>If you are an investor, a potential B2B partner for SmartCabin, or a strategic partner interested in systems architecture, I'd love to connect.
          </p> 
        </div>
        <div className='md:flex px-24 py-12 mx-auto md:justify-center'>
          <Link to="/projects">
            <button className="px-48 py-12 mt-24 primary-color-dark no-border bold br-5 w-full md:auto nav-button ">
              View Our Portfolio
            </button>   
          </Link>
        </div>
      </div>
    </section>
    
  )
}

export default About